import { createSelector } from '@reduxjs/toolkit';
import { currentOrganizationId } from '../path';

import { userOrganizations } from './userOrganizations';

export const requiresSecureLogin = createSelector(
  currentOrganizationId,
  userOrganizations,
  function (organizationId, organizations) {
    if (organizationId !== null) {
      const len = organizations.length;

      for (let i = 0; i < len; i++) {
        if (organizations[i].id === organizationId) {
          return organizations[i].requiresSecureLogin;
        }
      }

      console.error('requiresSecureLogin, no organization found for id ', organizationId, organizations);
    }
    return false;
  },
);
